import { render, staticRenderFns } from "./SPIFProfitLoss.vue?vue&type=template&id=b4dbdfdc"
import script from "./SPIFProfitLoss.vue?vue&type=script&lang=js"
export * from "./SPIFProfitLoss.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfitLoss.vue?vue&type=style&index=0&id=b4dbdfdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports